import React, { ElementType } from 'react';

import {
  Link as MUILink,
  LinkProps as MUILinkProps,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router';

interface LinkProps extends MUILinkProps {
  component?: ElementType;
  target?: string;
  onClick?: (React.MouseEventHandler<HTMLAnchorElement> & React.MouseEventHandler<HTMLSpanElement>);
}

const Link = ({ children, href, target, onClick, ...rest }: LinkProps,
) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <MUILink
      variant="inherit"
      color={theme.palette.info.main}
      onClick={(e) => {
        if (onClick) onClick(e);
        if (!e.metaKey && href && !(href.startsWith('http://') || href.startsWith('https://'))) {
          e.preventDefault();
          e.stopPropagation();
          if (target) {
            window.open(`${window.location.origin}${href}`, target);
          } else {
            navigate(href);
          }
        }
      }}
      target={target}
      href={href}
      {...rest}
    >
      {children}
    </MUILink>
  );
};

export default Link;
